import React from 'react';
import { AnalyticsLocationProvider } from 'latitude-analytics';
import { Accordion } from '@latitude/accordion-rebrand';
import { SetupWrapper, SetupHeading, SetupLayout, PhonePanel, PhoneImage } from './AppleSetupAccordion.styled';
import Typography from '@latitude/typography';
import Section from '@latitude/section-rebrand';
import { REBRAND_COLOR } from '@latitude/core/utils/constants';
const COMPONENT_ID = 'apple-setup-accordion';

const APPLE_PAY_SETUP_ITEMS = [
  {
    id: 'iphone',
    title: 'iPhone',
    content: (
      <ul>
        <li>Open the Wallet app.</li>
        <li>Tap the &ldquo;+&rdquo; sign in the upper-right corner.</li>
        <li>
          Enter your card&rsquo;s security code to add your credit or debit
          card affiliated with your iTunes account. Or, select &ldquo;Add a
          different card,&rdquo; and use your iPhone camera to scan the card
          information.*
        </li>
      </ul>
    ),
  },
  {
    id: 'ipad',
    title: 'iPad',
    content: (
      <ul>
        <li>Go to Settings.</li>
        <li>
          Tap &ldquo;Wallet &amp; Apple Pay,&rdquo; and select &ldquo;Add
          Credit or Debit Card.&rdquo;
        </li>
        <li>
          Enter your card&rsquo;s security code to add your credit or debit
          card affiliated with your iTunes account. Or, select &ldquo;Add a
          different card,&rdquo; and use your iPhone camera to scan the card
          information.*
        </li>
      </ul>
    ),
  },
  {
    id: 'apple-watch',
    title: 'Apple Watch',
    content: (
      <ul>
        <li>Open the Apple Watch app on your iPhone.</li>
        <li>
          Tap &ldquo;Wallet &amp; Apple Pay&rdquo; and select &ldquo;Add
          Credit or Debit Card.&rdquo;
        </li>
        <li>
          Enter your card&rsquo;s security code to add your credit or debit
          card affiliated with your iTunes account. Or, select &ldquo;Add a
          different card,&rdquo; and use your iPhone camera to scan the card
          information.*
        </li>
      </ul>
    ),
  },
  {
    id: 'macbook-pro',
    title: 'MacBook Pro with Touch ID',
    content: (
      <ul>
        <li>Go to System Preferences.</li>
        <li>Select &ldquo;Wallet &amp; Apple Pay&rdquo; and select &ldquo;Add Card.&rdquo;</li>
        <li>
          Enter your card&rsquo;s security code to add your credit or debit
          card affiliated with your iTunes account.
        </li>
        <li>
          Or, select &ldquo;Add a different card,&rdquo; and use your iPhone
          camera to scan the card information.*
        </li>
      </ul>
    ),
  },
  {
    id: 'paying-in-stores',
    title: 'Paying in stores',
    content:
      'Apple Pay is the easiest way to pay in stores with your iPhone and Apple Watch. You can quickly check out using the devices you carry every day.',
  },
  {
    id: 'paying-in-apps',
    title: 'Paying in apps and on the web',
    content:
      'Use Apple Pay to make purchases in all kinds of apps on your iPhone and iPad. Paying is as simple as selecting Apple Pay at checkout and completing the payment using Face ID or Touch ID. Apple Pay is also the easier, safer way to pay online in Safari on your iPhone, iPad, and Mac, as you no longer have to create an account or fill out lengthy forms. Simply pay and go. You can also pay on your MacBook Pro using Touch ID.*',
  },
];

const ApplePaySetupAccordion = ({
  heading = 'How to set up Apple Pay',
  phoneImageUrl,
  items = APPLE_PAY_SETUP_ITEMS,
  trackingId,
  ...rest
}) => {
  const componentIdentifier = trackingId
    ? `${trackingId}-${COMPONENT_ID}`
    : COMPONENT_ID;

  return (
    <Section>
    <SetupWrapper className={`${componentIdentifier}-wrapper`} {...rest}>
      {heading && (
        <SetupHeading>
          <Typography.SH3>{heading}</Typography.SH3>
        </SetupHeading>
      )}

      <SetupLayout>
        {phoneImageUrl && (
          <PhonePanel>
            <PhoneImage src={phoneImageUrl} alt="Apple Pay on iPhone" />
          </PhonePanel>
        )}
  
        <AnalyticsLocationProvider location="how to set up apple pay">
          <Accordion
          variant="outlined"
            titleBgColor={REBRAND_COLOR.WHITE}
            contentBgColor={REBRAND_COLOR.WHITE}
            fgColor={REBRAND_COLOR.MID_BLUE}
            css={`
              width: 100%;

              .bg-black-10 {
                padding: 16px 24px;
              }
              ul {
                margin: 0;
                padding-left: 20px;
              }
              li {
                margin-bottom: 8px;

                &:last-child {
                  margin-bottom: 0;
                }
              }
            `}
            items={items}
          />
        </AnalyticsLocationProvider>
      </SetupLayout>
    </SetupWrapper>
    </Section>
  );
};

export default ApplePaySetupAccordion;